/* lg-chat — 顧客向けAIチャットアシスタント（クライアント側）
   設計の要点:
   - AI応答・エラー文言は必ず textContent で挿入する（HTML直挿入禁止・XSS防止・P15）
   - 履歴は sessionStorage に保持し最大10往復でトリム（Worker 側の 20件制限と対）
   - honeypot input（name=website）は常に空で送る。bot が埋めると Worker が静かに捨てる
   - PDPモバイルでは下部固定カート(sticky-cta)の×閉じに追従してボタン位置を下げる
   - 状態同期に requestAnimationFrame は使わない（非表示タブで止まる・Case 131） */
(function () {
  var root = document.getElementById('lg-chat');
  if (!root) return;

  var endpoint = root.getAttribute('data-endpoint') || '';
  var pageHandle = root.getAttribute('data-product-handle') || '';

  var toggle = root.querySelector('.lg-chat__toggle');
  var panel = root.querySelector('.lg-chat__panel');
  var closeBtn = root.querySelector('.lg-chat__close');
  var body = root.querySelector('[data-lg-chat-messages]');
  var chips = root.querySelector('[data-lg-chat-chips]');
  var form = root.querySelector('[data-lg-chat-form]');
  var input = root.querySelector('[data-lg-chat-input]');
  var send = root.querySelector('[data-lg-chat-send]');
  if (!toggle || !panel || !body || !form || !input || !send) return;

  var HIST_KEY = 'lg_chat_history';
  var SID_KEY = 'lg_chat_session';
  var MAX_PAIRS = 10;
  var GREETING = 'こんにちは。Lime GardenのAIアシスタント（自動応答）です。商品やよくあるご質問についてお答えします。';
  var GENERIC_ERROR = '申し訳ございません、うまく応答できませんでした。時間をおいてお試しいただくか、下の窓口をご利用ください。';

  /* sessionStorage が使えない環境でも固定IDにしない（固定だと全訪問者の会話が
     D1 上で1つに混ざる・Codex P2）。メモリ変数に保持してページ内では安定させる */
  var memSid = null;
  function genUuid() {
    return (crypto && crypto.randomUUID) ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  function sessionId() {
    try {
      var v = sessionStorage.getItem(SID_KEY);
      if (v) return v;
      v = genUuid();
      sessionStorage.setItem(SID_KEY, v);
      return v;
    } catch (e) {
      if (!memSid) memSid = genUuid();
      return memSid;
    }
  }

  function loadHistory() {
    try {
      var h = JSON.parse(sessionStorage.getItem(HIST_KEY) || '[]');
      return Array.isArray(h) ? h : [];
    } catch (e) {
      return [];
    }
  }
  function saveHistory(h) {
    while (h.length > MAX_PAIRS * 2) h.shift();
    try { sessionStorage.setItem(HIST_KEY, JSON.stringify(h)); } catch (e) {}
  }

  /* メッセージは textContent のみで描画（AI出力・エラーとも） */
  function addBubble(role, text) {
    var div = document.createElement('div');
    div.className = 'lg-chat__msg lg-chat__msg--' + (role === 'user' ? 'user' : 'ai');
    div.textContent = text;
    body.appendChild(div);
    body.scrollTop = body.scrollHeight;
    return div;
  }

  var typingEl = null;
  function showTyping() {
    typingEl = document.createElement('div');
    typingEl.className = 'lg-chat__msg lg-chat__msg--typing';
    typingEl.textContent = '入力中…';
    body.appendChild(typingEl);
    body.scrollTop = body.scrollHeight;
  }
  function hideTyping() {
    if (typingEl && typingEl.parentNode) typingEl.parentNode.removeChild(typingEl);
    typingEl = null;
  }

  function renderHistory() {
    body.textContent = '';
    addBubble('ai', GREETING);
    var h = loadHistory();
    for (var i = 0; i < h.length; i++) addBubble(h[i].role, h[i].content);
  }

  var busy = false;
  function sendMessage(text) {
    text = (text || '').trim().slice(0, 500);
    if (!text || busy) return;
    busy = true;
    send.disabled = true;
    input.disabled = true;
    if (chips) chips.style.display = 'none';

    var history = loadHistory();
    history.push({ role: 'user', content: text });
    saveHistory(history);
    addBubble('user', text);
    showTyping();

    var payload = {
      session_id: sessionId(),
      messages: loadHistory(),
      page: { url: location.pathname, product_handle: pageHandle },
      website: (form.querySelector('input[name="website"]') || { value: '' }).value
    };

    fetch(endpoint + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        hideTyping();
        var reply = r.ok && r.data && r.data.reply ? r.data.reply : (r.data && r.data.fallback) || GENERIC_ERROR;
        addBubble('ai', reply);
        if (r.ok && r.data && r.data.reply) {
          var h = loadHistory();
          h.push({ role: 'assistant', content: r.data.reply });
          saveHistory(h);
        }
      })
      .catch(function () {
        hideTyping();
        addBubble('ai', GENERIC_ERROR);
      })
      .then(function () {
        busy = false;
        send.disabled = false;
        input.disabled = false;
        input.focus();
      });
  }

  /* ── 開閉 ── */
  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'AIアシスタントを閉じる');
    renderHistory();
    if (loadHistory().length > 0 && chips) chips.style.display = 'none';
  }
  /* 念のため初期状態を JS 側でも閉じに倒す（CSS が読み込まれる前でも開いて見えないように） */
  panel.hidden = true;
  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'AIアシスタントを開く');
  }
  toggle.addEventListener('click', function () {
    if (panel.hidden) openPanel(); else closePanel();
  });
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value;
    input.value = '';
    sendMessage(t);
  });
  if (chips) chips.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.lg-chat__chip') : null;
    if (btn) sendMessage(btn.textContent);
  });

  /* ── PDPモバイル: sticky-cta の×閉じ / 非表示に追従 ──
     rAF ではなく setTimeout ベース（Case 131: 非表示タブでrAFは止まる）。
     失敗しても 88px 固定のままで実害なし（try/catch で本体を守る） */
  try {
    if (root.classList.contains('lg-chat--pdp')) {
      var syncCta = function () {
        var bar = document.querySelector('.sticky-cta');
        var closed = !bar || bar.classList.contains('sticky-cta--hidden') || bar.offsetHeight === 0;
        root.classList.toggle('lg-chat--cta-closed', closed);
      };
      syncCta();
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-sticky-cta-close]')) {
          setTimeout(syncCta, 0);
        }
      }, true);
    }
  } catch (e) { /* 位置調整の失敗はチャット本体に影響させない */ }
})();
